import React from 'react';
import '../App.css';
import '../bootstrap.css';
import UserPanel2 from './foodLogging/UserPanel2';
import { SUBSCRIPTION_STATUS, findAndAddUserNameToStatus } from '../helpers/Database';
import { TODOList } from './todos/TODOList.js';
import { TODO_INREPLYTO } from './todos/TODO.js';
import * as TodoUtil from '../helpers/TodoUtil';
import { itemsAreEqualByKey, getLocalDateString, DEFAULT_TIMEZONE, ADMIN_MAP } from '../helpers/Util';
import * as Database from '../helpers/Database';
import moment from 'moment';
import imgNoNewMessages from "./icons/noNewMessages-favicon.png";
import imgNewMessages from "./icons/newMessages-favicon.png";
import Favicon from 'react-favicon';

let _ = require('lodash');
const SMALL_SCREEN_WIDTH = 800;

async function getStage(todoItemId) {
  return await TodoUtil.getPropertyAsync('userSubscriptions/' + todoItemId, 'stage');
}

function isNotPaused(status) {
  return status !== SUBSCRIPTION_STATUS.Paused;
}

export default class Main extends React.Component {
  constructor(props) {
    super(props);
    this.migratedUsersList = [];
    this.migratedUsersDict = {};

    this.state = {
      faviconUrl: imgNoNewMessages,
      width: window.innerWidth,
      height: window.innderHeight,

      userId: "",// We input this.
      freePlanUserId: "",
      genericUserId: "",
      migratedUsersList: [],
      migratedUsersDict: {},

      todoAutofillText: "",

      // And get back these
      userName: "",
      userToken: "",
      mfpName: "",
      workoutsMap: {},
      dailyHabitsMap: {},
      weeklyHabitsMap: {},

      selectedOption: "botControls",
      selectedLogOption: "logFoods",
      selectedExerciseOption: "workouts",
      genericMessageToSend: "",

      // Status messages. Make sure these are included in clearMessages()
      errorMessage: "",
      successMessage: "",

      todoItems: {},
      dataEntryModeOverride: false,
      fullViewOverride: false,
    }

    Database.doOnValueChange(`adminTool/faviconRed/coach`, (key, val) => {
      this.faviconRedCoach = val;
      this.onFaviconChange();
    });

    Database.doOnValueChange(`adminTool/faviconRed/data`, (key, val) => {
      this.faviconRedData = val;
      this.onFaviconChange();
    });

    this.handleWindowSizeChange = this.handleWindowSizeChange.bind(this);
    this.unhighlightUsername = this.unhighlightUsername.bind(this);
    this.highlightUsername = this.highlightUsername.bind(this);
    this.makeAPICall = this.makeAPICall.bind(this);
    this.clearMessages = this.clearMessages.bind(this);
    this.selectedUserChange = this.selectedUserChange.bind(this);
    this.getUserSubmit = this.getUserSubmit.bind(this);
    this.checkClientMidsSubmit = this.checkClientMidsSubmit.bind(this);
    this.clearClientMidsSubmit = this.clearClientMidsSubmit.bind(this);
    this.getFreePlanUserChange = this.getFreePlanUserChange.bind(this);
    this.askUserAboutFreePlan = this.askUserAboutFreePlan.bind(this);
    this.genericUserChange = this.genericUserChange.bind(this);
    this.genericTextChange = this.genericTextChange.bind(this);
    this.showUserTryHealthCoachingButton = this.showUserTryHealthCoachingButton.bind(this);
    this.showUserTryHealthCoachingButton2 = this.showUserTryHealthCoachingButton2.bind(this);
    this.refreshUserPanelClick = this.refreshUserPanelClick.bind(this);
    this.todoItemsCache = {};
    this.v2TodoItemsCache = {}; // Used for merging logic see _mergeTodoItemsV2
    this.todosRefreshTimer = {};
    this.v2StateFlushTimer = null;

    // NOTE: These TodoUtil event listeners below should really be paired w/a call to a Database.clear* call to unhook event listener.
    // but since this is only initiated in the constructor, okay to keep omitting that part. FUTURE: Move this stuff below into componentWillMount
    // or something and add calls to unhook event listeners in componentWillUnmount.

    // Regular TODOs
    TodoUtil.onNewTodoItem(async (todoItemId) => {
      try {
        // Make a separate request to get todoItem. This is b/c there's no guarantee of order in which the child_changed
        // event comes in, which means if a lot of newMessages get created in a short time (as with multiple food logging),
        // a more outdated TODO child_changed event can overwrite a newer one. Related Asana bug: https://app.asana.com/0/286104021310008/588735322545321
        // FUTURE: Hook child_changed listeners to the children of the TODO at leaf level.
        this.todosRefreshTimer[todoItemId] = null;
        clearTimeout(this.todosRefreshTimer[todoItemId]);
        this.todosRefreshTimer[todoItemId] = setTimeout(async () => {
          let stage = await getStage(todoItemId);

          let todoItem = await TodoUtil.getTodoItemAsync(todoItemId);
          let v2TodoItem = _.get(this.v2TodoItemsCache, `${todoItemId}[0]`, null);
          if (v2TodoItem) {
            todoItem = this._mergeTodoItemsV2(todoItem, v2TodoItem);
          }
          this.todoItemsCache[todoItemId] = [todoItem, stage];
          this._scheduleV2StateFlush();
        }, 100);
      } catch (e) {
        console.log(e.stack);
      }
    }, false);

    TodoUtil.onTodoItemUpdate(async (todoItemId) => {
      try {
        // Make a separate request to get todoItem. This is b/c there's no guarantee of order in which the child_changed
        // event comes in, which means if a lot of newMessages get created in a short time (as with multiple food logging),
        // a more outdated TODO child_changed event can overwrite a newer one. Related Asana bug: https://app.asana.com/0/286104021310008/588735322545321
        // FUTURE: Hook child_changed listeners to the children of the TODO at leaf level.
        this.todosRefreshTimer[todoItemId] = null;
        clearTimeout(this.todosRefreshTimer[todoItemId]);
        this.todosRefreshTimer[todoItemId] = setTimeout(async () => {
          let stage = await getStage(todoItemId);

          let todoItem = await TodoUtil.getTodoItemAsync(todoItemId);

          let v2TodoItem = _.get(this.v2TodoItemsCache, `${todoItemId}[0]`, null);
          if (v2TodoItem) {
            todoItem = this._mergeTodoItemsV2(todoItem, v2TodoItem);
          }

          this.todoItemsCache[todoItemId] = [todoItem, stage];
          this._scheduleV2StateFlush();
        }, 100);
      } catch (e) {
        console.log(e.stack);
      }
    }, false);

    TodoUtil.onRemovedTodoItem((todoItemId) => {
      delete this.todoItemsCache[todoItemId];
      this.setState({
        todoItems: this.todoItemsCache
      });
    }, false);

    Database.doOnUserStatusUpdate(async (userId, userStatus) => {
      if (userStatus.name === userStatus.email) {
        // This should only happen if this user just registered with the app (and the app doesn't know their name so it defaults to assigning email as name)
        userStatus.name = await findAndAddUserNameToStatus(userStatus);
      }

      this.migratedUsersList.push({
        id: userId,
        name: userStatus.name + (userStatus.lastName ? ' ' + userStatus.lastName : ''),
        email: userStatus.email,
      });

      this.migratedUsersList.sort(function (a, b) {
        if (a.name > b.name) { return 1; }
        else if (a.name < b.name) { return -1; }
        else { return 0; }
      });

      this.migratedUsersDict[userId] = {
        name: userStatus.name,
        email: userStatus.email,
        timezoneOffset: userStatus.timezoneOffset ? userStatus.timezoneOffset : DEFAULT_TIMEZONE
      };

      this._scheduleV2StateFlush();
    });

    // One listener across every user's userTodos/{userId}/dataEntry. This used to be one listener per userStatus doc
    // (1000+), which got this client throttled by Firestore (resource-exhausted) and delayed todo updates by minutes.
    Database.initAllDataEntryTodosListener((todoItem, todoItemId, userId) => {
      let formattedTodo = {};
      let today = new Date();
      let todayDateString = getLocalDateString(today, DEFAULT_TIMEZONE);
      formattedTodo['newMessage'] = {};
      let newTodoContent = {
        todoId: todoItemId,
        logId: todoItem.logId,
        inReplyTo: TODO_INREPLYTO.DataEntryFood,
        description: todoItem.originalText,
        fullMsg: todoItem.originalText,
        recurrence: todayDateString + '-None-na:na',
        containsQuestion: false,
        dataEntryContent: todoItem,
        isV2: true
      };

      if (!this.todoItemsCache[userId]) {
        formattedTodo['newMessage'][todoItemId] = newTodoContent;
        this.todoItemsCache[userId] = [formattedTodo, '' /* stage */];
      } else if (!this.todoItemsCache[userId][0]['newMessage']) {
        this.todoItemsCache[userId][0]['newMessage'] = {
          [todoItemId]: newTodoContent
        };
      } else {
        this.todoItemsCache[userId][0]['newMessage'][todoItemId] = newTodoContent;
      }

      this.v2TodoItemsCache[userId] = this.todoItemsCache[userId];

      this._scheduleV2StateFlush();
    }, (todoItemId, userId) => {
      delete this.todoItemsCache[userId][0]['newMessage'][todoItemId];
      this._flushV2StateNow();
    });
  }

  // Firestore listeners fire once per user/todo on initial load, and React 16 doesn't batch setState calls made
  // outside of event handlers, so calling setState directly re-renders the whole tree (every DataEntryTodoForm)
  // hundreds of times. Coalesce them into one setState since the caches are mutated in place anyway.
  _scheduleV2StateFlush = () => {
    if (this.v2StateFlushTimer) {
      return;
    }
    this.v2StateFlushTimer = setTimeout(this._flushV2StateNow, 100);
  }

  // Removals render immediately (they're rare, so no render storm) and also flush anything pending.
  _flushV2StateNow = () => {
    clearTimeout(this.v2StateFlushTimer);
    this.v2StateFlushTimer = null;
    this.setState({
      migratedUsersList: this.migratedUsersList,
      migratedUsersDict: this.migratedUsersDict,
      todoItems: this.todoItemsCache
    });
  }

  // For v2 merging of todods with 'newMessage' vs all other types of todos
  _mergeTodoItemsV2(v1TodoItem, v2TodoItem) {
    // This will ignore all "newMessage" todos for v1 todos if any v2 ones exist.
    // TODO: Make this smarter during fix for https://app.asana.com/0/369325020744465/1200088752173767
    v1TodoItem['newMessage'] = v2TodoItem['newMessage'];
    return v1TodoItem;
  }

  onFaviconChange = () => {
    if (this.faviconRedCoach && this.faviconRedData) {
      this.makeFaviconRed();
    } else if (!this.faviconRedCoach && !this.faviconRedData) {
      this.makeFaviconNormal();
    } else if (this.faviconRedCoach && !this.faviconRedData) {
      if (this.isFullView()) {
        this.makeFaviconRed();
      } else if (this.isDataView()) {
        this.makeFaviconNormal();
      } else {
        this.makeFaviconRed();
      }
    } else {
      if (this.isFullView()) {
        this.makeFaviconRed();
      } else if (this.isDataView()) {
        this.makeFaviconRed();
      } else {
        this.makeFaviconNormal();
      }
    }
  }

  componentDidMount = () => {
    if (ADMIN_MAP[this.props.adminId].isDataEntry) {
      document.addEventListener('click', () => {
        Database.setFirebaseEntry('adminTool/lastDEPClick', Date.now());
      })
    }
  }

  makeFaviconRed = () => {
    if (!this.faviconRed) {
      // var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      // link.type = 'image/x-icon';
      // link.rel = 'shortcut icon';
      // link.href = imgNewMessages;
      // document.getElementsByTagName('head')[0].appendChild(link);
      this.setState({
        faviconUrl: imgNewMessages
      })
      this.faviconRed = true;
    }
  }

  makeFaviconNormal = () => {
    if (this.faviconRed) {
      this.setState({
        faviconUrl: imgNoNewMessages
      })
      this.faviconRed = false;
    }
  }

  setUnansweredUsers(users, usersVarName) {
    this.props.firebase.database().ref('lastResponses/unansweredUsers').on('child_added', (unansweredUserSnapshot) => {
      let unansweredUserId = unansweredUserSnapshot.key;
      users.forEach(pp => {
        if (pp.id === unansweredUserId) {
          pp.backgroundColor = "yellow";
          var unansweredUserInfo = unansweredUserSnapshot.val();
          pp.previewText = unansweredUserInfo.previewText ? unansweredUserInfo.previewText : "";
          let newState = {};
          newState[usersVarName] = users;
          this.setState(newState);
          var promise = document.getElementById('sound').play();
          if (promise !== undefined) {
            promise.then(_ => {
              // Autoplay started!
            }).catch(error => {
              // Autoplay was prevented.
              // Show a "Play" button so that user can start playback.
            });
          }
        }
      })
    });

    this.props.firebase.database().ref('lastResponses/unansweredUsers').on('child_changed', (unansweredUserSnapshot) => {
      let unansweredUserId = unansweredUserSnapshot.key;
      users.forEach(pp => {
        if (pp.id === unansweredUserId) {
          var unansweredUserInfo = unansweredUserSnapshot.val();
          pp.previewText = unansweredUserInfo.previewText ? unansweredUserInfo.previewText : "";
          let newState = {};
          newState[usersVarName] = users;
          this.setState(newState); // Same as child_added but don't play sound again, just change preview text
        }
      })
    });

    this.props.firebase.database().ref("lastResponses/unansweredUsers").on('child_removed', (unansweredUserSnapshot) => {
      let unansweredUserId = unansweredUserSnapshot.key;
      users.forEach(pp => {
        if (pp.id === unansweredUserId) {
          pp.backgroundColor = "white";
          pp.previewText = "";
          let newState = {};
          newState[usersVarName] = users;
          this.setState(newState);
        }
      })
    });
  }

  async componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
    Database.releaseUserInteractionAsync(this.props.adminId, 'dataEntry');
    Database.releaseUserInteractionAsync(this.props.adminId, 'chat');

    this.freePlanners = [];
    let pathRef = this.props.firebase.database().ref('freePlanners');
    pathRef.once("value").then(function (snapshot) {
      if (snapshot.exists()) {
        let users = snapshot.val();
        let uids = Object.keys(users);
        uids.forEach(uid => {
          let user = users[uid];
          if (user.status === "active") {
            this.freePlanners.push({ id: uid, name: user.name });
          }
        })
        this.freePlanners.sort(function (a, b) {
          if (a.name > b.name) { return 1; }
          else if (a.name < b.name) { return -1; }
          else { return 0; }
        });
        this.setState({ freePlanners: this.freePlanners });
      }
    }.bind(this), function (error) {
      console.error("The read from firebase at freePlanners failed: " + error);
    });

    //================
    // COACH SCRIPT
    //================
    // get tags and coaching scripts from database
    let scriptsCache = await TodoUtil.getPropertyAsync("coachScript");
    this.setState({ scripts: scriptsCache });

    //===============================
    // get, order and set L1 items
    //===============================
    let srcKeys = Object.keys(scriptsCache);
    let destL1 = [];

    for (var i = 0; i < srcKeys.length; i++) {
      destL1[scriptsCache[srcKeys[i]].order] = srcKeys[i];
    }
    this.setState({ L1items: destL1 });

    //======================================
    // get, order and set L2 and L3 items
    //======================================
    let destL2 = [], destL3 = [];
    let currL1item = Object.keys(scriptsCache)[0];
    let startL2Index = 0, startL3Index = 0;
    Object.keys(scriptsCache).map((L1item) => {
      let L2Objs = scriptsCache[L1item];          // per L1 item object: {<food keys>}, {<exercise keys>}...
      let L2Keys = Object.keys(L2Objs);           // L2 items: food-habit-discussion, food-kudos...

      // Fill L2items array: [L1item id, L1 items's L2 id, L1 item's L2 description, className value]
      for (var i = 0; i < L2Keys.length; i++) {
        if (currL1item != L1item) {
          startL2Index = destL2.length;
          currL1item = L1item;
        }

        if (L2Objs[L2Keys[i]].description) {    // skip L2 keys like "description" which are not objects
          if (_.get(L2Objs, [L2Keys[i], L2Keys[i] + "-FAQ1"])) {
            destL2[L2Objs[L2Keys[i]].order + startL2Index] = [L1item, L2Keys[i], L2Objs[L2Keys[i]].description, "L3arrow"];

            var j = 1;
            // Fill L3items array: [L2item id, L2 items's shorthand, L2 item's description]
            while (j > 0) {
              let L3Obj = _.get(L2Objs, [L2Keys[i], L2Keys[i] + "-FAQ" + j], undefined);        // {<food-habit-discussion keys>}...

              if (L3Obj != undefined) {
                destL3[L3Obj.order + startL3Index] = [
                  L2Keys[i],
                  L3Obj.shorthand,
                  L3Obj.description,
                  L2Keys[i] + "-FAQ" + j,
                  L3Obj.url,
                  L3Obj.urlTitle
                ];
                j++;
              }
              else {
                startL3Index = destL3.length;
                j = 0;
              }
            }

            startL3Index = destL3.length;
          }
          else {
            destL2[L2Objs[L2Keys[i]].order + startL2Index] = [L1item, L2Keys[i], L2Objs[L2Keys[i]].description, "L3arrow makeInvisible"];
          }
        }
      }
    })
    this.setState({ L2items: destL2 });
    this.setState({ L3items: destL3 });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
    Database.clearAllCallbacks('lastResponses/unansweredUsers');
    Database.clearAllCallbacks('adminTool/faviconRed');
  }

  handleWindowSizeChange() {
    this.setState({
      width: window.innerWidth,
      height: window.innerHeight
    });
  }

  unhighlightUsername(e) {
    e.preventDefault();
    this.props.firebase.database().ref("lastResponses/unansweredUsers/" + e.target.name).set(null);
  }

  highlightUsername(e) {
    e.preventDefault();
    this.props.firebase.database().ref("lastResponses/unansweredUsers/" + e.target.name).set({
      previewText: "[Admin-highlighted]"
    });
  }

  makeAPICall(path, json, callbackOnSuccess /* optional */) {
    fetch(process.env.REACT_APP_API_URL + path, {
      method: 'POST',
      body: JSON.stringify(json),
      headers: { "Content-Type": "application/json" }
    })
      .then(res => {
        if (!res.ok) {
          return { error: res.statusText }
        }
        else {
          return res.json();
        }
      })
      .then(body => {
        this.clearMessages();
        if (callbackOnSuccess) { callbackOnSuccess(body); }
        else {
          if (body.error) { this.setState({ errorMessage: body.error }) }
          else if (body.success) { this.setState({ successMessage: body.success }) }
        }
      })
      .catch(err => {
        this.setState({ errorMessage: err.message })
      });
  }

  clearMessages() {
    this.setState({
      successMessage: "",
      errorMessage: "",
      botPausedMessage: "",
      checkClientMidsMessage: ""
    });
  }

  selectedUserChange(e) {
    if (e.target.value != "blank") {
      this.getUserSubmit(e.target.value, '');
    }
  }

  getFreePlanUserChange(e) {
    this.setState({ freePlanUserId: e.target.value });
  }

  genericUserChange(e) {
    this.setState({ genericUserId: e.target.value });
  }

  genericTextChange(e) {
    this.setState({ genericMessageToSend: e.target.value });
  }

  playNotifySoundIfCoachTodoStillRed = (userId) => { // Only called for coaches. Play sound of the triggering user still has any red 'coach' TODOs that are high pri
    let todoItemsForUser = _.get(this.todoItemsCache, `${userId}[0]`);
    if (todoItemsForUser) {
      for (let todoType in todoItemsForUser) {
        let todoTypeCollection = todoItemsForUser[todoType];
        for (let todoId in todoTypeCollection) {
          let todoItem = todoTypeCollection[todoId];
          if (
            (todoItem.inReplyTo != TODO_INREPLYTO.DataEntry ||
              todoItem.inReplyTo != TODO_INREPLYTO.DataEntryManual ||
              todoItem.inReplyTo != TODO_INREPLYTO.DataEntryFood) &&
            (todoType === 'newMessage' || todoItem.importance === 'high') &&
            (!todoItem.recurrence || todoItem.recurrence.includes('None-na:na'))
          ) {
            this.playNotifySound();
            return;
          }
        }
      }
    }
  }

  playNotifySound = () => {
    var promise = document.getElementById('sound').play();
    if (promise !== undefined) {
      promise.then(_ => {
        // Autoplay started!
      }).catch(error => {
        // Autoplay was prevented.
        // Show a "Play" button so that user can start playback.
      });
    }
  }

  async getUserSubmit(userId, todoMetadata) {
    // Don't sign out old user. If you do this, then all the firebase event listeners get
    // unhooked (like for the unansweredUsers one). You're going to sign in new user anyway.
    if (userId != this.state.userId) {
      if (this.state.migratedUsersDict[userId]) {
        this.setState({ userId: userId })
      } else {
        this.setState({
          showLoadingMessage: true // show loading message since we have to wait for Auth of new user to complete
        });

        this.makeAPICall('/getUser', { user_id: userId }, (body) => { // TODO: Don't need this after master auth is impl
          let newState = {};
          if (body.error) {
            newState.errorMessage = body.error;
          } else if (body.userName) {
            newState.userName = body.userName;
            newState.userId = userId;
            newState.workoutsMap = body.workoutIds ? body.workoutIds : {};
            newState.dailyHabitsMap = body.dailyHabitIds ? body.dailyHabitIds : {};
            newState.weeklyHabitsMap = body.weeklyHabitIds ? body.weeklyHabitIds : {};
          } else {
            newState.errorMessage = `No name found for userId ${userId}`;
          }
          this.setState(newState);
          //console.log(this.state.userName + ", " + this.state.userId);
        });
      }
    }

    if (!itemsAreEqualByKey(todoMetadata, this.state.todoMetadata, 'todoId')) {
      this.setState({ todoMetadata: todoMetadata });
    }

    // paste the right stuff in chatbox if metadata exist
    if (!todoMetadata) {
      return;
    }

    if (todoMetadata.todoShorthand === 'ateLessThan66Percent' ||
      todoMetadata.todoShorthand === 'ateMoreThan66Percent'
    ) {
      let dataName = todoMetadata.todoDataType;
      let today = new Date();
      let todayDateString = getLocalDateString(today, DEFAULT_TIMEZONE); // FUTURE: This must change when we start supporting ppl outside NA.
      Database.doOnReadingFirebaseEntry(`users/${todoMetadata.userId}/goalLogs/food/${dataName}/${todayDateString}`, snapshot => {
        if (snapshot.val()) {
          let goalLogEntry = snapshot.val();
          if (goalLogEntry.goal) {
            let goal = goalLogEntry.goal;
            let actual = goalLogEntry.actual ? goalLogEntry.actual : 0;
            let percentMet = _.round(actual / goal * 100);

            let autofillText = (percentMet <= 100) ?
              `Heads up! You're now ${percentMet}% of the way to your daily ${dataName} target.` :
              `Heads up! You're now ${percentMet - 100}% over your daily ${dataName} target.`;

            this.setState({ todoAutofillText: { message: autofillText, tag: 'food-habit-discussion', effortCase: 'verbatim-faq' } });
          } else {
            this.setState({ todoAutofillText: { message: '', tag: 'food-habit-discussion', effortCase: 'verbatim-faq' } });
          }
        } else {
          this.setState({ todoAutofillText: { message: '', tag: 'food-habit-discussion', effortCase: 'verbatim-faq' } });
        }
      });
      // Database.doOnReadingFirebaseEntry(`users/${todoMetadata.userId }/goals/food/weeklyGoals/${NUTRITION_DATA_SHOW_MAP[dataName]}`, snapshot => {
      //   if (snapshot.val()) {
      //     let autofillText = `Heads up! you are  __% of the way to your daily ___ target. Let me know if you'd like to brainstorm strategies to meet your goal today!`;
      //     this.setState({ todoAutofillText: { message: foodsYesterdayStr.trim(), tag: 'food-habit-discussion', effortCase: 'verbatim-faq'} });
      //   } else {
      //     this.setState({ todoAutofillText: { message: '', tag: 'food-habit-discussion', effortCase: 'verbatim-faq'} });
      //   }
      // });
    } else {
      switch (todoMetadata.todoShorthand) {
        case "QYesterdayLog":
          let yesterday = moment().subtract(1, "days").format("YYYY-MM-DD");
          let foodsYesterdayObj = await TodoUtil.getPropertyAsync("users/" + todoMetadata.userId + "/diary/food/" + yesterday, "foods");

          let foodsYesterdayStr = "";
          if (foodsYesterdayObj === null) {
            foodsYesterdayStr = "How was yesterday? Do you want to log what you ate yesterday?"
          }
          else {
            foodsYesterdayStr = "You had a lot of room left yesterday. Just to double check: did you eat anything besides the following yesterday?\n"
            Object.keys(foodsYesterdayObj).map((key) => {
              let foodName = foodsYesterdayObj[key].name;
              if (foodName != undefined)
                foodsYesterdayStr += "• " + foodName + "\n";
            })
          }

          this.setState({ todoAutofillText: { message: foodsYesterdayStr.trim(), tag: 'food-question', effortCase: 'verbatim-faq' } });
          break;
        case "OverTarget":
          this.setState({ todoAutofillText: { message: "Test", tag: 'food-question', effortCase: 'verbatim-faq' } });
          break;
        case "progressCheckTime":
          let weeklyStartDay = await TodoUtil.getPropertyAsync("users/" + todoMetadata.userId + "/weeklyStartDay");

          let weeklyStartDayName;
          switch (weeklyStartDay) {
            case 0:
              weeklyStartDayName = "Sunday";
              break;
            case 1:
              weeklyStartDayName = "Monday";
              break;
            case 2:
              weeklyStartDayName = "Tuesday";
              break;
            case 3:
              weeklyStartDayName = "Wednesday";
              break;
            case 4:
              weeklyStartDayName = "Thursday";
              break;
            case 5:
              weeklyStartDayName = "Friday";
              break;
            case 6:
              weeklyStartDayName = "Saturday";
              break;
            default:
              weeklyStartDayName = "_";
          }

          this.setState({
            todoAutofillText: {
              message: "Just to confirm: I'll remind you to weigh yourself and measure your waist every " + weeklyStartDayName + " morning. Is 7am sufficiently early enough for you to have time to do so before you eat?",
              tag: 'bodystat-discussion',
              effortCase: 'verbatim-faq'
            }
          });
          break;
        case "tipSaveRecipe":
          this.setState({
            todoAutofillText: {
              message: "Pro-tip: if you listed ingredients for a dish, you can save it as a recipe with me so next time you can just say the recipe name and I'll know the ingredients.",
              tag: 'food-report',
              effortCase: 'verbatim-faq'
            }
          });
          break;
        case "tipRecipeLink":
          this.setState({
            todoAutofillText: {
              message: "Pro-tip: you can send me a recipe link and I'll automatically extract the nutrition information from it.",
              tag: 'food-report',
              effortCase: 'verbatim-faq'
            }
          });
          break;
        case "tipSameAs":
          this.setState({
            todoAutofillText: {
              message: "Pro-tip: if you ate the same foods as a prior meal, just say 'same as <meal> <day>' or '<dish> from <day>' and I'll know what you mean.",
              tag: 'food-report',
              effortCase: 'verbatim-faq'
            }
          });
          break;
        case "tipOutExercise":
          this.setState({
            todoAutofillText: {
              message: "Regarding adding back exercise calories to your total calorie intake, I don't encourage my clients to do so. The reasons are:\n1) Fitness trackers greatly overestimate calories burned and so most ppl who rely on this don't end up making progress.\n2) Using exercise to make up for diet contributes to compensatory behaviors where you use exercise to punish yourself for overeating or use food to reward yourself for exercising.\n\nI don't encourage this kind of mindset as it's not sustainable in the long run.",
              tag: 'exercise-habit-discussion',
              effortCase: 'verbatim-faq'
            }
          });
          break;
        case "tipTrackingAccuracy":
          this.setState({
            todoAutofillText: {
              message: "I notice that you strive for accuracy with the nutrition label. Did you know that the FDA allows those nutrition labels to be 20% off in accuracy? There is no such thing as 'accurate' when it comes to calorie counting unfortunately.\n\nWhat's important is your trends. So as long as we're consistent in how we count the calories for the same food day-to-day, our data plan is solid. Does this make sense?",
              tag: 'food-report',
              effortCase: 'verbatim-faq'
            }
          });
          break;
        case "setShortTermGoal":
          this.setState({
            todoAutofillText: {
              message: "I am glad we have a long-term goal in place. I would love to discuss if you have a short-term goal, maybe 3 months out, that you'd like to set. This often helps my clients keep their momentum going.\n\nDo you have an event coming up to which you can anchor this short-term goal?",
              tag: 'bodystat-goal',
              effortCase: 'verbatim-faq'
            }
          });
          break;
        default:    // reset state so the same text doesn't get pasted on every TODO click
          this.setState({ todoAutofillText: { message: '', tag: 'select tag', effortCase: 'unique' } });
      }
    }
  }

  submitLoggingForm(todoItemPath) {
    let pathParts = todoItemPath.split('/');
    let dataEntryId = pathParts[pathParts.length - 1];

    // If this is the same dataEntryId as the previous one, append & increment a counter at the end so we allow submitting
    // multiple times should a previous attempt fail
    if (this.state.onSubmitDataEntryId) {
      let prevIdSplit = this.state.onSubmitDataEntryId ? this.state.onSubmitDataEntryId.split('!') : null;
      if (prevIdSplit) {
        let newOnSumbitId = this.state.onSubmitDataEntryId;
        let prevDataEntryId = prevIdSplit[0];
        if (prevDataEntryId === dataEntryId) {
          if (prevIdSplit.length === 1) { // Shouldn't happen, but if it does, then just reset to 0.
            newOnSumbitId = `${prevDataEntryId}!0`;
          } else { // Assume 2 parts
            let counter = _.toNumber(prevIdSplit[1]);
            newOnSumbitId = `${prevDataEntryId}!${counter + 1}`;
          }
          this.setState({ onSubmitDataEntryId: newOnSumbitId });
        } else {
          this.setState({ onSubmitDataEntryId: `${dataEntryId}!0` });
        }
      } else {
        this.setState({ onSubmitDataEntryId: `${dataEntryId}!0` });
      }
    } else {
      this.setState({ onSubmitDataEntryId: `${dataEntryId}!0` });
    }
  }

  askUserAboutFreePlan(e) {
    e.preventDefault();
    this.makeAPICall('/askUserAboutFreePlan', {
      user_id: this.state.genericUserId,
      message: this.state.genericMessageToSend
    }, (body) => {
      if (body.error) {
        this.setState({ errorMessage: body.error })
      }
      else if (body.success) {
        this.setState({ successMessage: body.success })
      }
    });
  }

  showUserTryHealthCoachingButton(e) {
    e.preventDefault();
    this.makeAPICall('/showTryHealthCoachingButton', {
      user_id: this.state.genericUserId,
      message: this.state.genericMessageToSend
    }, (body) => {
      if (body.error) {
        this.setState({ errorMessage: body.error })
      }
      else if (body.success) {
        this.setState({ successMessage: body.success })
      }
    });
  }

  showUserTryHealthCoachingButton2(e) {
    e.preventDefault();
    this.makeAPICall('/showTryHealthCoachingButton2', {
      user_id: this.state.genericUserId,
      message: this.state.genericMessageToSend
    }, (body) => {
      if (body.error) {
        this.setState({ errorMessage: body.error })
      }
      else if (body.success) {
        this.setState({ successMessage: body.success })
      }
    });
  }

  checkClientMidsSubmit(e) {
    e.preventDefault();
    this.makeAPICall('/checkClientMids', {}, (body) => { // TODO: Don't need to make API call anymore
      if (body.error) { this.setState({ errorMessage: body.error }) }
      else if (body.success) { this.setState({ checkClientMidsMessage: body.success }) }
    });
  }

  clearClientMidsSubmit(e) { // TODO: Don't need to make API call anymore
    e.preventDefault();
    this.makeAPICall('/clearClientMids', {});
  }

  refreshUserPanelClick(e) {
    e.preventDefault();
    this.setState({ // TODO: Temp solution, since I can't easily get UP to autorefresh :/
      showLoadingMessage: false
    })
  }

  componentDidUpdate() {
    if (this.state.userName && (this.state.userName != this.state.oldUserName)) {
      // Need to wait for userName to change because that's the signal for when Auth is complete.
      this.setState({
        oldUserName: this.state.userName,
        showLoadingMessage: false
      });
    }
  }

  async logout() {
    await Database.releaseUserInteractionAsync(this.props.adminId, 'dataEntry');
    await Database.releaseUserInteractionAsync(this.props.adminId, 'chat');
    this.props.firebase.auth().signOut().then(() => {
      this.props.loggedOut();
    }).catch((error) => {
      console.error(error.code + ": " + error.message);
      this.setState({ errorMessage: error.code + ": " + error.message });
    });
  }

  loggingInProgress(isInProgress) {
    this.setState({ loggingInProgress: isInProgress });
  }

  enabledataEntryModeOverride = (e) => {
    this.setState({
      dataEntryModeOverride: e.target.checked
    });
  }

  enablefullViewOverride = (e) => {
    this.setState({
      fullViewOverride: e.target.checked
    });
  }

  toggleTextCoachOnNewHighPriTodo = (e) => {
    this.setState({
      textCoachOnNewHighPriTodo: e.target.checked
    })
    Database.setFirebaseEntry(`adminTool/enableTexts/${this.props.adminId}`, e.target.checked);
  }

  postDataEntryTodosCheck = (type) => {
    if (ADMIN_MAP[this.props.adminId].isDataEntry) {
      if (type === 'exercise') {
        Database.createTODOAsync(this.state.userId, 'Data Entry Person just sent exercise report.', 'medium', null, 'manual', null, TODO_INREPLYTO.CoachArchived);
      } else { // Assuming food
        Database.createTODOAsync(this.state.userId, 'Data Entry Person just sent food report.', 'medium', null, 'manual', null, TODO_INREPLYTO.CoachArchived);
      }
    }
  }

  isDataView() {
    return ADMIN_MAP[this.props.adminId].isDataEntry || this.state.dataEntryModeOverride;
  }

  isFullView() {
    return this.state.fullViewOverride;
  }

  render() {
    let isLargeScreen = this.state.width > SMALL_SCREEN_WIDTH;
    let userPanel;
    if (this.state.showLoadingMessage) {
      userPanel =
        (<div style={{ position: "absolute", top: "25%", left: "25%", padding: "10px" }}>LOADING ...</div>);
    } else if (this.state.migratedUsersDict[this.state.userId]) {
      userPanel =
        (<UserPanel2
          firebase={this.props.firebase}
          userId={this.state.userId}
          userStatus={this.state.migratedUsersDict[this.state.userId]}
          isLargeScreen={isLargeScreen}
          todoMetadata={this.state.todoMetadata ? this.state.todoMetadata : {}}
          onSubmitDataEntryId={this.state.onSubmitDataEntryId}
          adminId={this.props.adminId}
          todoItems={_.get(this.state.todoItems, `${this.state.userId}[0]`, null) ? this.state.todoItems[this.state.userId][0] : []}
          loggingInProgress={this.loggingInProgress.bind(this)}
          dataEntryMode={ADMIN_MAP[this.props.adminId].isDataEntry || this.state.dataEntryModeOverride}
          fullViewMode={this.state.fullViewOverride}
        />);
    }

    let migratedUsers =
      (
        <div>
          <select onChange={this.selectedUserChange}>
            <option value="blank">{"== Users =="}</option>
            {
              this.state.migratedUsersList.map((migratedUser) =>
                <option key={migratedUser.id} value={migratedUser.id}>{migratedUser.name}</option>
              )
            }
          </select>
        </div>
      )

    return (
      <div >
        <Favicon url={this.state.faviconUrl} />
        <div style={{ color: "red" }}>{this.state.errorMessage}</div>
        {
          this.state.loggingInProgress ? (
            <div style={{
              backgroundColor: 'rgba(150,150,150,0.5)', position: 'absolute', width: '100%', height: '200%',
              zIndex: '2', textAlign: 'center', top: '600px', fontSize: '80px', color: 'red', top: '0', left: '0'
            }}>Waiting...</div>) : (<span />)
        }

        <fieldset disabled={this.state.loggingInProgress}>
          <div className="row" style={{ overflow: "auto", margin: "10px" }}>
            <div style={{ width: "20%", minWidth: "180px", maxWidth: "300px" }}>
              <div>
                <TODOList todoItems={this.state.todoItems} onClick={this.getUserSubmit}
                  submitLoggingForm={this.submitLoggingForm.bind(this)} userId={this.state.userId}
                  adminId={this.props.adminId} dataEntryMode={ADMIN_MAP[this.props.adminId].isDataEntry || this.state.dataEntryModeOverride}
                  playNotifySoundIfCoachTodoStillRed={this.playNotifySoundIfCoachTodoStillRed}
                  playNotifySound={this.playNotifySound}
                  fullViewMode={this.state.fullViewOverride} migratedUsers={this.state.migratedUsersDict}
                />
              </div>
              <div>
                {
                  !_.isEmpty(this.state.todoItems) ?

                    Object.keys(this.state.todoItems).map(todoItemId => {
                      let todoItem = this.state.todoItems[todoItemId];
                      if (todoItem && todoItem[0] && todoItem[0]['newMessage']) {
                        let todoItemKeys = Object.keys(todoItem[0]['newMessage']);
                        let hasV2Todo = false;
                        for (let todoItemKey of todoItemKeys) {
                          if (todoItem[0]['newMessage'][todoItemKey].isV2) {
                            hasV2Todo = true;
                          }
                        }
                        if (hasV2Todo) {
                          return <li>{this.state.migratedUsersDict[todoItemId] ? this.state.migratedUsersDict[todoItemId].name : '--'}</li>;
                        }
                      }
                      return <span />;
                      // let todoItem = this.state.todoItems[todoItemId];
                      // if (_.isEmpty(todoItem[0])) {
                      //   console.error(`TODOList error: todoItem[0] is null or undefined for userId todoItemId ${todoItemId}`);
                      // } else {
                      //   Object.keys(todoItem[0]).map((msgType) => {
                      //     let FbId = todoItem[0][msgType];

                      //     if (_.isEmpty(FbId)) { // will be null for v2 migrated users
                      //       //console.error(`TODOList error: FbId is null or undefined for userId todoItemId ${todoItemId} and msgType ${msgType}`);
                      //     } else {
                      //       Object.keys(FbId).map((id) => {
                      //         let inner = FbId[id];
                      //         return <li>{todoItemId}</li>;
                      //       })
                      //     }
                      //   })
                      // }
                    }
                    ) : <span />
                }
              </div>
              <hr />
              <div>
                <div className="dropdown">
                  {migratedUsers}
                </div>
                <hr />
                <input type='submit' value='Log out' onClick={this.logout.bind(this)}></input>
                {
                  !ADMIN_MAP[this.props.adminId].isDataEntry ?
                    <span>
                      <input style={{ marginLeft: '20px' }} type="checkbox" checked={this.state.dataEntryModeOverride} dataToggle="toggle" onClick={this.enabledataEntryModeOverride} /> Data view
                    </span> : <span />
                }
                {
                  // !ADMIN_MAP[this.props.adminId].isDataEntry ?
                  //   <div style={{marginTop: '20px'}}>
                  //     <input type="checkbox" checked={this.state.textCoachOnNewHighPriTodo} dataToggle="toggle" onClick={this.toggleTextCoachOnNewHighPriTodo}/> Text me when new high-pri TODO shows up
                  //   </div> : <span/>
                }
              </div>
            </div>
            <div className="col" style={{ width: "80%" }}>
              {userPanel}
            </div>
          </div>
        </fieldset>

        {/*<hr/>
          {nonOnboardedUsers}*/}
        <audio id='sound' preload='auto'>
          <source src='https://viva-bot.herokuapp.com/sounds/notify2.mp3' type='audio/mpeg' />
          <embed hidden='true' autostart='false' loop='false' src='https://viva-bot.herokuapp.com/sounds/notify2.mp3' />
        </audio>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/main/Main.js